module.exports = __webpack_public_path__ + "img/teatro.cdc6c02f.jpg";